import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class AppsService {
  constructor(private api: CloudFunctionsApiService) {}

  getApps() {
    return this.api.snapshotList('/apps');
  }

  getAppById(app) {
    return this.api.documentChange(`/apps/${app}`);
  }

  createdApp(app) {
    return this.api.post('/apps', app).toPromise();
  }

  editApp(app) {
    return this.api.patch(`/apps/${app.id}`, app).toPromise();
  }
}
